import { render, staticRenderFns } from "./RedemptionImportedUrn.vue?vue&type=template&id=06389416&"
import script from "./RedemptionImportedUrn.vue?vue&type=script&lang=js&"
export * from "./RedemptionImportedUrn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports